<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/ForgotPasswordSecure'

    export default {
        components: {
            Grid,
        }
    }
</script>